// extracted by mini-css-extract-plugin
module.exports = {"typing":"writingMotion_typing__o1b2J","dot":"writingMotion_dot__rAmAt","loadingFade":"writingMotion_loadingFade__FhhWy"};